import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const PlansInfo = () => {
  const { toast } = useToast();

  const { data: plans, isLoading: plansLoading } = useQuery({
    queryKey: ["plans"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("plans")
        .select("*")
        .order("max_workspaces");
      
      if (error) {
        console.error("Error fetching plans:", error);
        toast({
          title: "Error",
          description: "Could not fetch plans",
          variant: "destructive",
        });
        throw error;
      }
      
      return data;
    },
  });

  const { data: userPlan, isLoading: userPlanLoading } = useQuery({
    queryKey: ["userPlan"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("profiles")
        .select("*, plans(*)")
        .eq("id", user.id)
        .single();
      
      if (error) {
        console.error("Error fetching user plan:", error);
        toast({
          title: "Error",
          description: "Could not fetch user plan",
          variant: "destructive",
        });
        throw error;
      }
      
      return data;
    },
  });

  if (plansLoading || userPlanLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="space-y-6 p-6">
      <Card>
        <CardHeader>
          <CardTitle>Your Current Plan</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <p className="text-2xl font-bold">{userPlan?.plans?.name}</p>
            <p>Max Organizations: {userPlan?.plans?.max_organizations}</p>
            <p>Max Workspaces: {userPlan?.plans?.max_workspaces}</p>
            <p>Max Boards per Workspace: {userPlan?.plans?.max_boards_per_workspace}</p>
            <p>Max Pomodoros per Workspace: {userPlan?.plans?.max_pomodoros_per_workspace}</p>
            <p>Can Add Collaborators: {userPlan?.plans?.can_add_collaborators ? "Yes" : "No"}</p>
            <p>Can Share with External Users: {userPlan?.plans?.can_share_with_external_users ? "Yes" : "No"}</p>
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {plans?.map((plan) => (
          <Card key={plan.id}>
            <CardHeader>
              <CardTitle>{plan.name}</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <p>Max Organizations: {plan.max_organizations}</p>
                <p>Max Workspaces: {plan.max_workspaces}</p>
                <p>Max Boards per Workspace: {plan.max_boards_per_workspace}</p>
                <p>Max Pomodoros per Workspace: {plan.max_pomodoros_per_workspace}</p>
                <p>Can Add Collaborators: {plan.can_add_collaborators ? "Yes" : "No"}</p>
                <p>Can Share with External Users: {plan.can_share_with_external_users ? "Yes" : "No"}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};